import { skins } from 'src/vuex/getters'

export default {
  vuex: {
    getters: {
      skins
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    open: {
      require: true,
      type: Boolean,
      twoWay: true
    },
    width: {
      type: String,
      coerce: (x) => `${x}px`,
      default: '100%'
    },
    callback: {
      type: Function,
      coerce: x => x
    },
    effect: { type: String, default: null },
    backdrop: { type: Boolean, default: true },
    large: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },

  data () {
    return {}
  },

  methods: {
    close () {
      this.$set('open', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dialogs/_shared/traits.js